import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";
import type { ShipmentOptionsRequest, ShipmentOptionsResponse } from "./shipment-options.types";

const SHIPMENT_OPTIONS_PATH = "/shipment-options";

export class ShipmentOptionsService extends BaseService {
  public constructor() {
    super(API_BASE_URL);
  }

  public async getShipmentOptions(request: ShipmentOptionsRequest): Promise<ShipmentOptionsResponse> {
    const query = new URLSearchParams({
      make: request.make,
      model: request.model,
      orderType: request.orderType,
    });
    const response = await this.fetch(`${SHIPMENT_OPTIONS_PATH}?${query.toString()}`);
    if (!response.ok) {
      throw new Error(`Shipment options API error: ${response.status}`);
    }
    return (await response.json()) as ShipmentOptionsResponse;
  }
}
